<template>
  <div
    v-if="nextRefreshAt"
    v-tooltip.right="tooltipText"
    class="conversation-list-refresh-indicator"
  >
    <fluent-icon icon="clock" size="18" view-box="-6 0 117 120" />
    <span>{{ countdownLabel }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      now: Date.now(),
      tickId: null,
    };
  },
  computed: {
    ...mapGetters({
      nextRefreshAt: 'getConversationListNextRefreshAt',
    }),
    remainingMs() {
      if (!this.nextRefreshAt) return 0;
      return Math.max(0, this.nextRefreshAt - this.now);
    },
    countdownLabel() {
      const totalSeconds = Math.ceil(this.remainingMs / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${minutes}:${String(seconds).padStart(2, '0')}`;
    },
    tooltipText() {
      const minutes = Math.max(1, Math.ceil(this.remainingMs / 60000));
      const key =
        minutes === 1
          ? 'CHAT_LIST.AUTO_REFRESH.TOOLTIP_SINGULAR'
          : 'CHAT_LIST.AUTO_REFRESH.TOOLTIP_PLURAL';
      return this.$t(key, { minutes });
    },
  },
  watch: {
    nextRefreshAt(value) {
      if (value) {
        this.startTicking();
      } else {
        this.stopTicking();
      }
    },
  },
  mounted() {
    if (this.nextRefreshAt) {
      this.startTicking();
    }
  },
  beforeDestroy() {
    this.stopTicking();
  },
  methods: {
    startTicking() {
      if (this.tickId) return;
      this.now = Date.now();
      this.tickId = setInterval(() => {
        this.now = Date.now();
      }, 1000);
    },
    stopTicking() {
      if (this.tickId) {
        clearInterval(this.tickId);
        this.tickId = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.conversation-list-refresh-indicator {
  display: flex;
  align-items: center;
  gap: var(--space-smaller);
  color: var(--c-500);
  font-size: var(--font-size-mini);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  cursor: default;

  span {
    color: var(--color-heading);
    font-weight: var(--font-weight-medium);
  }

  @media screen and (max-width: 768px) {
    gap: 0;

    span {
      display: none;
    }
  }
}
</style>
